module.exports = __webpack_public_path__ + "img/6.90a78334.webp";